<div class="holy-grail">
  <app-top-navigation></app-top-navigation>
  <div class="holy-grail-body">
    <main class="holy-grail-content">
      <div tabindex="0" class="content-expand" id="focus-container">
        <ng-container *ngIf="header">
          <!-- This is a hidden h1 that is available to screen readers for accessibility. Any other headers in the application should be h2 or below. -->
          <h1 [attr.aria-label]="header" class="cdk-visually-hidden">
            {{ header }}
          </h1>
        </ng-container>
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
  <footer>
    <app-footer></app-footer>
  </footer>
</div>
